import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]

  connect() {
    // Mostrar el modal automáticamente cuando se conecta el controlador
    if (this.hasModalTarget) {
      // Esperar a que el DOM esté completamente listo y que Bootstrap/jQuery esté disponible
      this.showModal()
    }
  }

  showModal() {
    // Intentar múltiples veces con diferentes métodos
    const tryShow = () => {
      if (typeof $ !== 'undefined' && $.fn.modal) {
        // Método 1: jQuery Bootstrap (Bootstrap 4)
        try {
          // Remover aria-hidden antes de mostrar para evitar warnings
          this.modalTarget.removeAttribute('aria-hidden')
          $(this.modalTarget).modal({
            backdrop: 'static',
            keyboard: false
          })
          $(this.modalTarget).modal('show')
          // Asegurar que aria-hidden sea false después de mostrar
          requestAnimationFrame(() => {
            this.modalTarget.setAttribute('aria-hidden', 'false')
          })
          return true
        } catch (e) {
          console.warn('Error showing modal with jQuery:', e)
        }
      }

      if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
        // Método 2: Bootstrap 5 nativo
        try {
          // Remover aria-hidden antes de mostrar
          this.modalTarget.removeAttribute('aria-hidden')
          const modal = new bootstrap.Modal(this.modalTarget, {
            backdrop: 'static',
            keyboard: false
          })
          modal.show()
          // Asegurar que aria-hidden sea false después de mostrar
          requestAnimationFrame(() => {
            this.modalTarget.setAttribute('aria-hidden', 'false')
          })
          return true
        } catch (e) {
          console.warn('Error showing modal with Bootstrap 5:', e)
        }
      }

      // Método 3: Fallback manual
      try {
        // Establecer aria-hidden='false' ANTES de mostrar y enfocar elementos
        this.modalTarget.removeAttribute('aria-hidden')
        this.modalTarget.setAttribute('aria-hidden', 'false')
        this.modalTarget.classList.add('show')
        this.modalTarget.style.display = 'block'
        document.body.classList.add('modal-open')

        // Crear backdrop si no existe
        let backdrop = document.querySelector('.modal-backdrop')
        if (!backdrop) {
          backdrop = document.createElement('div')
          backdrop.className = 'modal-backdrop fade show'
          document.body.appendChild(backdrop)
        }

        // Enfocar el primer elemento enfocable después de que el modal esté visible
        requestAnimationFrame(() => {
          const firstFocusable = this.modalTarget.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
          if (firstFocusable) {
            firstFocusable.focus()
          }
        })
        return true
      } catch (e) {
        console.error('Error showing modal manually:', e)
        return false
      }
    }

    // Intentar inmediatamente
    if (!tryShow()) {
      // Si falla, intentar después de un delay
      setTimeout(() => {
        if (!tryShow()) {
          // Último intento después de más tiempo
          setTimeout(() => tryShow(), 500)
        }
      }, 100)
    }
  }
}
